namespace $ { export class $mol_lister extends $mol_viewer {

	/// minHeightStyle \
	minHeightStyle() {
		return ""
	}

	/// field * style.minHeight < minHeightStyle
	field() {
		return $mol_merge_dict( super.field() , {
			"style.minHeight" : ()=> <any> this.minHeightStyle() ,
		} )
	}

	/// rows /
	rows() {
		return [] as any[]
	}

	/// childs < rows
	childs() {
		return this.rows()
	}

} }

